import '../../css/Preloader.scss'

const Preloader = () => {
  return (
    <div className='preloader-wrapper'>
      <div className='preloader'>
        <svg className='circular' viewBox='25 25 50 50'>
          <circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='4' />
        </svg>
      </div>
    </div>
  )
}

export default Preloader
